import styled from "styled-components";

const TeamMemberStyleWrapper = styled.article`
  .team_card {
    background: #131740;
    backdrop-filter: blur(10px);
    max-width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 50px 20px;
    border-radius: 10px;
    border : 1px solid #FF06B7;


    h3 {
      color: #ffffff;
      font-size: 24px;
      line-height: 34px;
      text-align: center;
      margin-top: 28px;
      margin-bottom: 4px;
    }

    h4 {
      font-family: "Poppins";
      font-style: normal;
      text-align: center;
      font-size: 16px;
      line-height: 19px;
      color: rgba(255, 255, 255, 0.8);
      margin: 0;
    }
  }

  .team_social_icon {
    width: 100%;
    position: absolute;
    bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;

    ul {
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 197px;
      width: 100%;
      margin: 0;
      padding: 0;

      li {
        height: 35px;
        width: 37px;
        background: #0f181d;
        opacity: 0;
        transition: 0.4s;
        background: #FF06B7;
        border-radius: 5px;
        display: flex;
        align-items: center;

        a {
          display: flex;
          align-items: flex-end;
          justify-content: center;
          height: 100%;
          width: 100%;
          color: #ffffff;
          align-items: center;
        }
      }
    }
  }

  &:hover {
    &:hover {
      .team_social_icon {
        ul {
          li {
            opacity: 1;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 991px) {
    .team_card {
      h3 {
        font-size: 18px;
        line-height: 28px;
      }
    }
  }
`;

export default TeamMemberStyleWrapper;
